export default __webpack_public_path__ + "static/media/pets.d7591199.svg";